import { DeliveryProvider, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  text: {
    status: {
      [OrderFulfillmentStatus.Rejected]: 'Bist du sicher?',
    },
    [OrderMethod.Pickup]: 'Ist die Bestellung abholbereit?',
    [OrderMethod.OnSite]: 'Wurde die Bestellung an den Tisch serviert?',
    [OrderMethod.Delivery]: {
      [DeliveryProvider.Standalone]: 'Ist die Lieferung in Zustellung?',
      [DeliveryProvider.UberDrive]: 'Hat der Fahrer die Bestellung bereits abgeholt?',
      [DeliveryProvider.FirstDelivery]: 'Hat der Fahrer die Bestellung bereits abgeholt?',
      [DeliveryProvider.WoltDrive]: 'Hat der Fahrer die Bestellung bereits abgeholt?',
    },
  },
  buttons: {
    cancel: 'Nein, Abbrechen',
    confirm: 'Ja',
  },
};
